import { createBrowserRouter, Navigate } from 'react-router-dom';
import Home from '../pages/Home';
import MainLayout from '../layouts/MainLayout';
import { NAVIGATION_ROUTES } from './constants';
import SignUp from '../pages/auth/SignUp';
import SignIn from '../pages/auth/SignIn';
import EmailVerification from '../pages/auth/EmailVerification';
import LearningResource from '@/pages/LearningResource';
import AddProduct from '@/pages/AddProduct';
import ManageProduct from '@/pages/ManageProduct';
import AllOrders from '@/pages/AllOrders';
import ReturnOrders from '@/pages/ReturnOrders';
import Reviews from '@/pages/Reviews';
import VoucherManagement from '@/pages/VoucherManagement';
import ReportsAndMetrics from '@/pages/ReportsAndMetrics';
import UserManagement from '@/pages/UserManagement';
import SetPassword from '@/pages/auth/SetPassword';
import RegistrationSuccess from '@/pages/auth/EmailVerification/Registration/success';
import ForgotPassword from '@/pages/auth/Password/forgot';
import ForgotPasswordLink from '@/pages/auth/ForgotPasswordLink';
import ResetPassword from '@/pages/auth/Password/Reset';
import ResetPasswordSuccess from '@/pages/auth/ResetPasswordSuccess';
import ProductDetail from '@/pages/ProductDetail';
import ReviewsByProduct from '@/pages/Reviews/ReviewsByProduct';
import Settings from '@/pages/Settings';
import Unauthorized from '@/components/common/UnAuthorized';
import Dashboard from '@/pages/Dashboard';
import EmptyRoute from '@/components/common/EmptyRoute';
import TOC from '@/pages/TOC';
import PaymentDetails from '@/pages/PaymentDetails';
import ProtectedRoute from './ProtectedRoute';
// import ImageOptimizer from '@/components/AddProduct/ImageOptimizer';
import ImageOptimizerPage from '@/pages/ImageOptimizer';

export const isAuthenticated = () => {
  const user = localStorage.getItem('vendor-auth-storage');
  if (user) {
    const parsedUser = JSON.parse(user);
    return parsedUser?.state?.user?.id != null;
  }
  return false;
};
export const router = createBrowserRouter([
  {
    path: '/',
    element: isAuthenticated() ? (
      <Navigate to={NAVIGATION_ROUTES.HOME} />
    ) : (
      <Navigate to={NAVIGATION_ROUTES.SIGNIN} />
    ),
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <MainLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: NAVIGATION_ROUTES.HOME,
        element: <Home />,
      },
      {
        path: NAVIGATION_ROUTES.LEARNING_RESOURCES,
        element: <LearningResource />,
      },
      {
        path: NAVIGATION_ROUTES.ADD_PRODUCT,
        element: <AddProduct />,
      },
      {
        path: NAVIGATION_ROUTES.EDIT_PRODUCT,
        element: <AddProduct />,
      },
      {
        path: NAVIGATION_ROUTES.IMAGECROPPER,
        element: <ImageOptimizerPage />,
      },
      {
        path: NAVIGATION_ROUTES.MANAGE_PRODUCT,
        element: (
          <>
            <ManageProduct />
          </>
        ),
      },

      {
        path: NAVIGATION_ROUTES.VIEW_PRODUCT,
        element: <ProductDetail />,
      },
      {
        path: NAVIGATION_ROUTES.ALL_ORDERS,
        element: <AllOrders />,
      },
      {
        path: NAVIGATION_ROUTES.RETURN_ORDERS,
        element: <ReturnOrders />,
      },
      {
        path: NAVIGATION_ROUTES.REVIEWS,
        element: <Reviews />,
      },
      {
        path: NAVIGATION_ROUTES.REVIEWS_BY_PRODUCT,
        element: <ReviewsByProduct />,
      },
      {
        path: NAVIGATION_ROUTES.VOUCHER_MANAGEMENT,
        element: <VoucherManagement />,
      },
      {
        path: NAVIGATION_ROUTES.REPORTS_AND_METRICS,
        element: <ReportsAndMetrics />,
      },
      {
        path: NAVIGATION_ROUTES.USER_MANAGEMENT,
        element: <UserManagement />,
      },
      {
        path: NAVIGATION_ROUTES.PAYMENT_DETAILS,
        element: <PaymentDetails />,
      },
      {
        path: NAVIGATION_ROUTES.SETTINGS,
        element: <Settings />,
      },
      {
        path: NAVIGATION_ROUTES.TOC,
        element: <TOC />,
      },
      {
        path: NAVIGATION_ROUTES.DASHBOARD,
        element: <Dashboard />,
      },
    ],
  },
  {
    path: NAVIGATION_ROUTES.SIGNUP,
    element: <SignUp />,
  },
  {
    path: NAVIGATION_ROUTES.SIGNIN,
    element: <SignIn />,
  },
  {
    path: NAVIGATION_ROUTES.LOGIN,
    element: <SignIn />,
  },

  {
    path: NAVIGATION_ROUTES.EMAILVERIFICATION,
    element: <EmailVerification />,
  },
  {
    path: NAVIGATION_ROUTES.SETPASSWORD,
    element: <SetPassword />,
  },
  {
    path: NAVIGATION_ROUTES.REGISTRATION.SUCCESS,
    element: <RegistrationSuccess />,
  },
  {
    path: NAVIGATION_ROUTES.PASSWORD.FORGOT,
    element: <ForgotPassword />,
  },
  {
    path: NAVIGATION_ROUTES.PASSWORD.RESET,
    element: <ResetPassword />,
  },
  {
    path: NAVIGATION_ROUTES.FORGOT_PASSWORD_LINK,
    element: <ForgotPasswordLink />,
  },
  {
    path: NAVIGATION_ROUTES.RESET_PASSWORD_SUCCESS,
    element: <ResetPasswordSuccess />,
  },
  {
    path: NAVIGATION_ROUTES.UNAUTHORIZED,
    element: <Unauthorized />,
  },
  {
    path: '*',
    element: <EmptyRoute />,
  },
]);
